// src/components/Dashboard/AdminLogin.js
import React, { useState } from 'react';
import './AdminLogin.css';

export default function AdminLogin({ onLogin }) {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!token.trim()) {
      setError('Please enter an admin token');
      return;
    }

    // Test the token by making a simple API call
    try {
      const response = await fetch('/api/admin/chefs?status=pending', {
        headers: {
          'Authorization': `Bearer ${token.trim()}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Invalid admin token');
      }

      // Token is valid, store it and notify parent
      localStorage.setItem('admin_token', token.trim());
      onLogin();
    } catch (error) {
      setError('Invalid admin token. Please check with your administrator.');
    }
  };

  return (
    <div className="admin-login">
      <div className="login-container">
        <h2>Admin Access Required</h2>
        <p>Please enter your admin token to access the chef approval system.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="admin-token">Admin Token:</label>
            <input
              id="admin-token"
              type="password"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Enter admin token..."
              className={error ? 'error' : ''}
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="login-btn">
            Access Admin Panel
          </button>
        </form>

        <div className="help-text">
          <h4>Need Help?</h4>
          <ul>
            <li>Contact your system administrator for the admin token</li>
            <li>This token is required to approve/reject chef applications</li>
            <li>Your token will be stored locally for this session</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
